<template>
    <div class="signInForm">
        <div class="pt-5 mx-3 pb-1">
            <div class="d-flex justify-content-center align-items-center">
                <img border="0" :src="imgPath" width="120" height="120" alt="">
            </div>
            <h2 class="text-center py-3 bg-single comment-color">{{ page_title }}</h2>
            <div class="bg-single">
                <div class="mx-sm-auto signContents comment-color mb-4">
                    <div v-if="complete_msg">
                        <p>会員情報の変更が完了しました。<br></p>
                        <p v-if="info_flag">アプリにてログアウト後、新しいメールアドレスで再度ログインしてください。<br></p>
                        <p v-else>メールが届かない場合は下記までお問合せください。<br>{{ info_mail }}</p>
                    </div>
                    <div v-if="fail_msg_area">
                        <p>{{ this.expiration }}</p>
                    </div>
                </div>
            </div>
            <div class="text-center mb-4" v-if="btnUse">
                <button class="confirmbutton" @click="logOutBtn">{{ btnName }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import MypageSideMenu from "./MypageSideMenu";
import Card from '../components/Card';
import { CHANGE_EMAIL } from "../../constants/mypage_info.js";
import ApolloClient from "apollo-boost";
import { MEMBER_LOG_OUT } from "../../constants/signout";

export default {
    components: {
        MypageSideMenu,
        Card
    },
    data() {
        return {
            url_token: "",
            url: "",
            email: "",
            accessToken: "",
            page_title: '会員情報変更完了',
            fail_msg: "",
            fail_msg_area: false,
            complete_msg: false,
            expiration: "",
            title_hidden: false,
            btnUse: false,
            btnName: '',
            info_flag: process.env.MIX_STYLE_NAME == 'hcgc' ? true: false,
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS,
            loadingCount: 0,
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png"
        };
    },
    created() {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            this.loadingOn();
            this.url_token = String(this.$route.query.token);
            if (this.url_token === 'undefined') {
                if (process.env.MIX_APP_URL) {
                    window.location.href = process.env.MIX_APP_URL;
                } else {
                    this.$router.push({ path: "/" });
                }
                return;
            }
            if (process.env.MIX_APP_URL) {
                this.btnUse = true;
                this.btnName = 'アプリを起動';
            } else {
                this.btnUse = true;
                this.btnName = 'ログインページに戻る';
            }
            this.$apollo
                .mutate({
                    mutation: CHANGE_EMAIL,
                    variables: { url_token: this.url_token }
                })
                .then(res => {
                    this.title_hidden = true;
                    this.complete_msg = true;
                    this.fail_msg_area = false;
                    this.title_hidden = true;
                    this.loadingOff();
                })
                .catch(error => {
                    if (error.graphQLErrors[0].message == "Invalid Url") {
                        this.expiration = this.$t("error.validation.expiration");
                    console.log(this.expiration);
                    } else {
                        if(error.graphQLErrors[0].message == "既にこのメールアドレスは登録されています。"){
                        this.expiration = error.graphQLErrors[0].message;
                        }else{
                        this.expiration = this.$t("error.validation.systemError");
                        }
                    }
                    this.title_hidden = false;
                    this.complete_msg = false;
                    this.fail_msg_area = true;
                    console.log(this.fail_msg_area);
                    this.loadingOff();
                });
        },
        logOutBtn () {
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                if (process.env.MIX_APP_URL) {
                    window.location.href = process.env.MIX_APP_URL;
                } else {
                    this.$router.push('/');
                }
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function　(){
            this.loadingCount++;
            this.$store.commit("loading/setIsLoading", true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function　(){
            this.loadingCount--;
            if (this.loadingCount == 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        }
    }
};
</script>

<style scoped>
@media screen and (min-width: 576px) {
    .signContents {
        width: 420px;
    }
}
.signInForm {
    height: 100vh;
}
</style>
